import { useQuery } from '@apollo/client/react';
import { MessageDocument, type MessageQuery } from 'graphql/generated/graphql';

export type TMessage = MessageQuery['message'];

/**
 * The message with this id, for the message page opened without the state of the messages table (a reload, a
 * direct link). A failed query (the message is missing) gives no message.
 */
const useGetMessage = ({ messageId, skip }: { messageId: string; skip: boolean }) => {
  const { data, loading } = useQuery(MessageDocument, { variables: { messageId }, skip });
  return { message: data?.message ?? null, loading };
};

export default useGetMessage;
